import { render } from "./MainGenerator.vue?vue&type=template&id=4f9f96f3"
import script from "./MainGenerator.vue?vue&type=script&lang=js"
export * from "./MainGenerator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\password-generator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__